import { Component, OnInit } from '@angular/core';
import { RouterPathHelper } from '../../../helpers/router-path-helper';
import { ActivatedRoute, Router } from '@angular/router';
import { Respondent } from '../../../models/respondent.model';
import { Observable } from 'rxjs';
import { ProcessParticipationService } from '../../../services/process.participation.service';
import { ProcessRespondentSelectionCriterionType } from '../../../models/process-models';
import { 
  RespondentsApprovalBusinessUnitSearchPageComponent 
} from '../../respondents-approval-business-unit-search-page/respondents-approval-business-unit-search-page.component';
import { ProcessService } from '../../../services/process.service';
import { RespondentsApprovalSearchPageComponent } from '../../respondents-approval-search-page/respondents-approval-search-page.component';

@Component({
  selector: 'app-except360-confirmation-respondents-detail',
  templateUrl: './except360-confirmation-respondents-detail.component.html',
  styleUrls: ['./except360-confirmation-respondents-detail.component.scss']
})
export class Except360ConfirmationRespondentsDetailComponent implements OnInit {
  processRespondents$: Observable<Array<Respondent>>;
  processAppraiseeDurationId: number;
  requirementType: number;
  respondentSelectionType: any = ProcessRespondentSelectionCriterionType;
  respondents: Array<Respondent>;

  private  routePathHelper: RouterPathHelper;
  private readonly respondentsApprovalSearchPageComponent = 'respondents-approval';
  private readonly respondentsApprovalBusinessUnitSearchPageComponent = 'business-units-approval';
  constructor(private route: ActivatedRoute,
    private readonly processParticipationService: ProcessParticipationService,
    private readonly router: Router, private processService: ProcessService) { }

  ngOnInit() {
    this.routePathHelper = new RouterPathHelper(this.route);
    this.route.paramMap.subscribe(params => {
      this.processAppraiseeDurationId  = +params.get('id');
      this.requirementType = +this.route.snapshot.paramMap.get('requirementType');
      this.processRespondents$ = this.processParticipationService.getRespondentsByProcessDurationAppraisee(this.processAppraiseeDurationId);
    });
  }

  deleteRespondent(respondent: Respondent) {
    this.processParticipationService
    .deleteFromApprove(this.processAppraiseeDurationId, respondent.id, this.requirementType)
      .subscribe(x => {
        const index = this.respondents.findIndex(r => r.id === respondent.id);
        if (index === -1) {
          return;
        }
        this.respondents.splice(index, 1);
      });
  }

  sortByRespondent(respondents: Array<Respondent>): Array<Respondent> {
    if (!respondents) {
      return;
    }
    return respondents.sort((a, b) => a.name.localeCompare(b.name));
  }

  navigateToSearchRespondent(selectionType: ProcessRespondentSelectionCriterionType) {
    const component = (selectionType === ProcessRespondentSelectionCriterionType.OtherRespondentMinAmount) ? 
    this.respondentsApprovalSearchPageComponent : this.respondentsApprovalBusinessUnitSearchPageComponent;
    const respondentsSearchPath = this.routePathHelper
    .getNavigationPath(this.processAppraiseeDurationId, component);
    this.router.navigate([respondentsSearchPath,
    {
      selectionType: selectionType,
      requirementType: this.requirementType
    }]);
  }

  approve() {
    this.processService.approveProcessAppraiseeRespondents(this.processAppraiseeDurationId, this.requirementType)
      .subscribe(x => this.getNavigationRoute());
  }

  getIsRespondentsExists(processReapondents): boolean {
    this.respondents = processReapondents;
    return this.respondents && this.respondents.length > 0;
  }

  private getNavigationRoute() {
    const parentUrl = this.route.snapshot.parent.routeConfig.path;
      this.router.navigate([`/${parentUrl}`,
        { requirementType: this.requirementType }]);
  }
}
